import Axios from "axios";
import { useLayoutEffect } from "react";
import { useDispatch } from "react-redux";
import { APP_COOKIE_NAME, LOGOUT, SHOW_NOTIFICATION } from "../constants";
import { deleteCookie, getCookie, setCookie } from "../utils";
import { installRequestInterceptors } from "./requestInterceptors";

export const BASE_URL =
  process.env.NODE_ENV === "production"
    ? "https://adema-api.deploy.ecoquimic.com"
    : "http://localhost:3005";

export const axios = Axios.create({ baseURL: BASE_URL });

const ConnectionHandler = () => {
  const dispatch = useDispatch();

  // Registrar una sola vez y antes de que los efectos de las pantallas pidan datos.
  useLayoutEffect(() => installRequestInterceptors(axios, {
    getToken: () => getCookie(APP_COOKIE_NAME),
    setToken: (token) => setCookie(APP_COOKIE_NAME, token, 1),
    onUnauthorized: async () => {
      await deleteCookie(APP_COOKIE_NAME);
      dispatch({ type: LOGOUT });
    },
    onError: (message) => dispatch({
      type: SHOW_NOTIFICATION,
      payload: { show: true, status: "error", message },
    }),
  }), [dispatch]);

  return null;
};

export default ConnectionHandler;
